import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur" data-id="element-375" data-mp="232nfsn0fptzi">
      <div className="bg-blue-950 px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-white sm:text-xs md:text-sm" data-id="element-376" data-mp="1y4vfb4lq4zjp">
        🇺🇸 The Complete Home Decluttering Decision System
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-slate-600 md:flex" data-id="element-377" data-mp="2qr6h2il2h6i3">
        <span className="flex items-center gap-1.5" data-id="element-378" data-mp="2lvr3lrqz1cm7">
          <ZapIcon className="h-3.5 w-3.5 text-yellow-700" data-id="element-379" data-mp="2h1mwn8hph4l4" /> Digital access in minutes
        </span>
        <span className="text-slate-300" data-id="element-380" data-mp="2c2sd24bwzbzy">·</span>
        <span className="flex items-center gap-1.5" data-id="element-381" data-mp="39iz6k30xg9l2">
          <LockIcon className="h-3.5 w-3.5 text-yellow-700" data-id="element-382" data-mp="39jr2xg2cmbce" /> Secure payment
        </span>
        <span className="text-slate-300" data-id="element-383" data-mp="34r7nedk3p64y">·</span>
        <span className="flex items-center gap-1.5" data-id="element-384" data-mp="34qfwvh5d1ylj">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-yellow-700" data-id="element-385" data-mp="26ixk1fm475e" /> 7-day guarantee
        </span>
      </div>
    </header>;
}